var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageSubscription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2428_15405",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2428_15405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 3.9974V11.9974C14.6654 12.3641 14.5348 12.678 14.2737 12.9391C14.0126 13.2002 13.6987 13.3307 13.332 13.3307H2.66536C2.2987 13.3307 1.98481 13.2002 1.7237 12.9391C1.46259 12.678 1.33203 12.3641 1.33203 11.9974V3.9974C1.33203 3.63073 1.46259 3.31684 1.7237 3.05573C1.98481 2.79462 2.2987 2.66406 2.66536 2.66406H13.332C13.6987 2.66406 14.0126 2.79462 14.2737 3.05573C14.5348 3.31684 14.6654 3.63073 14.6654 3.9974ZM2.66536 5.33073H13.332V3.9974H2.66536V5.33073ZM2.66536 7.9974V11.9974H13.332V7.9974H2.66536Z",
    fill: "#49454F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageSubscription);
export default __webpack_public_path__ + "static/media/manage-subscription.a6ee7f2a2906b1244c7fc9fbeeb1ab36.svg";
export { ForwardRef as ReactComponent };